var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "tag" }, [
    _vm._v("\n  " + _vm._s(_vm.tagText) + "\n  "),
    _c(
      "a",
      {
        on: {
          mousedown: function ($event) {
            $event.preventDefault()
            return _vm.deselect.apply(null, arguments)
          },
        },
      },
      [
        _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
          _c("path", {
            attrs: {
              d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z",
            },
          }),
          _vm._v(" "),
          _c("path", { attrs: { d: "M0 0h24v24H0z", fill: "none" } }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }